import { FiltersParams } from 'types/params';
import { SearchFilterMeta } from 'controllers/SearchController/types';
import { SuggestionsType, Suggestions } from '../types';
import getFilteredModifiersWithTotal from './getFilteredModifiersWithTotal';

const getSuggestionsFromFilters = ({
    total,
    instruments,
    genres,
    tags,
    sfxs,
}: {
    total: number;
    instruments: SearchFilterMeta | undefined;
    genres: SearchFilterMeta | undefined;
    tags: SearchFilterMeta | undefined;
    sfxs: SearchFilterMeta | undefined;
}): Suggestions[] => {
    const instrumentsModifiersWithTotal = getFilteredModifiersWithTotal(
        total,
        FiltersParams.instruments,
        instruments,
    );

    const genresModifiersWithTotal = getFilteredModifiersWithTotal(
        total,
        FiltersParams.genres,
        genres,
    );

    const tagsModifiersWithTotal = getFilteredModifiersWithTotal(
        total,
        FiltersParams.tags,
        tags,
    );

    const sfxsModifiersWithTotal = getFilteredModifiersWithTotal(
        total,
        FiltersParams.sfxs,
        sfxs,
    );

    // combine and order filter desc
    const combined = [
        ...instrumentsModifiersWithTotal,
        ...genresModifiersWithTotal,
        ...tagsModifiersWithTotal,
        ...sfxsModifiersWithTotal,
    ];
    const sorted = combined.sort(
        ([_, aTotal], [__, bTotal]) => bTotal - aTotal,
    );
    // remove total and add suggestions type
    const suggestions: Suggestions[] = sorted.map(([modifiers]) => [
        modifiers,
        SuggestionsType.Filters,
    ]);

    return suggestions;
};

export default getSuggestionsFromFilters;
